import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiDispatch } from '../../shared/ui/action.js';
import { useGenUiI18n } from '../../shared/ui/i18n.js';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { VoucherCancellationCard } from './ui/voucher_cancellation.js';

export { VoucherCancellationCard } from './ui/voucher_cancellation.js';

type VoucherCancellationUi = Extract<ChatUi, { kind: 'voucher_cancellation' }>;

/**
 * O confirm com o eco (a fala que a PESSOA aparenta ter dito) já traduzido no
 * idioma da sessão — mesmo padrão do `BusOffersEntry` (#2327): o locale mora no
 * `GenUiConfig`, `render` é uma função de catálogo (hook não roda ali), e um
 * componente resolve sem mover o texto para o card, que segue apresentacional.
 */
function VoucherCancellationEntry({
  ui,
  note,
  readOnly,
  dispatch,
}: Readonly<{
  ui: VoucherCancellationUi;
  note?: string;
  readOnly?: boolean;
  dispatch: GenUiDispatch;
}>) {
  const { t } = useGenUiI18n();
  return (
    <VoucherCancellationCard
      confirmation={ui.confirmation}
      note={note}
      readOnly={readOnly}
      onConfirm={
        readOnly
          ? undefined
          : (confirmation) => {
              dispatch({
                type: 'interaction',
                interactionId: confirmation.challengeId,
                text: t('voucherCancel.replyConfirm'),
              });
            }
      }
      onQuickReply={
        readOnly
          ? undefined
          : (text) => {
              dispatch({ type: 'reply', text });
            }
      }
    />
  );
}

/** Entrada de catálogo do `voucher_cancellation` (slot chat). O confirm ecoa o
 *  challengeId ESTRUTURADO (anti-LLM); o texto é só feedback visual. */
export const voucherCancellationEntry: GenUiEntry<VoucherCancellationUi> = {
  kind: 'voucher_cancellation',
  slot: 'chat',
  policy: {
    // Cada reemissão carrega um challenge NOVO (ex.: cancelar MAIS um voucher
    // depois de já ter confirmado) e deve aparecer como card acionável no turno
    // atual — reconciliar por id colapsaria sobre a linha antiga, congelada.
    reconcileById: false,
  },
  render: ({ ui, note, readOnly, dispatch }) => (
    <VoucherCancellationEntry
      ui={ui}
      {...(note ? { note } : {})}
      {...(readOnly ? { readOnly } : {})}
      dispatch={dispatch}
    />
  ),
};
